import { Component } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "adaa-manual-unallowed-page",
  imports: [TranslatePipe],
  template: `
    <div class="text-center text-secondary mt-5">
      <i class="adaa-icon-403 icon"></i>
      <p class="fs-2 fw-bold my-5">
        {{ "info.pmo_manual_progress" | translate }}
      </p>
    </div>
  `,
  styles: `
    .icon {
      font-size: 300px;
    }
  `,
})
export class ManualUnallowedPageComponent {}
